import { APIPost } from 'utilities/APIRequestHelper';
import apiURLBuilder from 'core/apiURLBuilder';
import { i18n } from 'core/i18n';
const { getLanguage } = i18n;

import signaturePatternActions from 'actions/signaturePattern';

import {
    ACCOUNT_CANCEL_MOTIVE_INPUT_CHANGED,
    ACCOUNT_CANCEL_MOTIVE_SELECT_CHANGED,
    ACCOUNT_CANCEL_SET_ACCOUNT_ID,
    ACCOUNT_CANCEL_SET_VISIBLE_STEP,
    ACCOUNT_CANCEL_SET_VALIDATE_STEP,
    ACCOUNT_CANCEL_SET_PRE_LEAVE_MODAL,
    ACCOUNT_CANCEL_SET_PRE_LEAVE_IS_PERSONAL_DATA,
    ACCOUNT_CANCEL_RESET_STATE,
    ACCOUNT_CANCEL_REQUEST,
    ACCOUNT_CANCEL_SUCCESS,
    ACCOUNT_CANCEL_FAIL,
} from 'constants/actionTypes';
import { OTP_AUTH_ACTION_EVENT } from 'constants/tagging';
import { MOTIVE_SELECT_OPTIONS_MAPPING } from '../routes/accountCancelView/constants';

const accountCancelMotiveSelectChanged = (payload) => ({
    type: ACCOUNT_CANCEL_MOTIVE_SELECT_CHANGED,
    payload
});

const accountCancelMotiveInputChanged = (payload) => ({
    type: ACCOUNT_CANCEL_MOTIVE_INPUT_CHANGED,
    payload
});

const setAccountId = (id) => ({
        type: ACCOUNT_CANCEL_SET_ACCOUNT_ID,
        payload: {
            id
        }
});

const setVisibleStep = (step) => ({
    type: ACCOUNT_CANCEL_SET_VISIBLE_STEP,
    payload: {
        step
    }
});

const validateStep = step => ({
    type: ACCOUNT_CANCEL_SET_VALIDATE_STEP,
    payload: {
        step
    }
});

const setPreLeaveModal = (show) => ({
    type: ACCOUNT_CANCEL_SET_PRE_LEAVE_MODAL,
    payload: {
        show
    }
});

const setPreLeaveIsPersonalData = (isPreLeavePersonalData) => ({
    type: ACCOUNT_CANCEL_SET_PRE_LEAVE_IS_PERSONAL_DATA,
    payload: {
        isPreLeavePersonalData
    }
});

const resetAccountCancelState = () => ({
    type: ACCOUNT_CANCEL_RESET_STATE
});

const cancelAccountRequest = () => ({
    type: ACCOUNT_CANCEL_REQUEST
});

const cancelAccountSuccess = () => ({
    type: ACCOUNT_CANCEL_SUCCESS
});

const cancelAccountFail = (error) => ({
    type: ACCOUNT_CANCEL_FAIL,
    payload: {
        error
    }
});

const requestCancelAccount = (immAccount) => (dispatch, getState) => {
    const callback = (dispatch, getState, dataToken) => {
        const product = immAccount.get('newProduct');
        const contractNumber = immAccount.get('newContractNumber');
        const motiveSelect = getState().accountCancel.get('motiveSelect');
        const motive = motiveSelect ? MOTIVE_SELECT_OPTIONS_MAPPING[motiveSelect] : "";
        const motiveKeyNameOnly = motive ? motive.split('-')[1] : "";
        const otherMotive = getState().accountCancel.get('motiveDetail');
        const language = getLanguage();
        const requestData = {
            header: {
                applicationLocale: language
            },
            query: {
                dataToken,
                product,
                contractNumber,
                motive: motiveKeyNameOnly,
                otherMotive
            }
        }

        dispatch(cancelAccountRequest());
        APIPost(dispatch, apiURLBuilder.getURL('cancelAccount'), requestData)
            .then(() => dispatch(cancelAccountSuccess()))
            .catch(error => {
                dispatch(cancelAccountFail(error));
                throw error;
            });
    }
    return Promise.resolve().then(function () {
        signaturePatternActions.validateAndExecute(dispatch, getState, callback, false, { customActionEvent: OTP_AUTH_ACTION_EVENT });
    })
}

module.exports = {
    accountCancelMotiveInputChanged,
    accountCancelMotiveSelectChanged,
    setAccountId,
    cancelAccountFail,
    setVisibleStep,
    validateStep,
    setPreLeaveModal,
    setPreLeaveIsPersonalData,
    resetAccountCancelState,
    requestCancelAccount,
};

